import StoreState from 'store/state'
import { createSelector } from 'reselect'
import { AdminState } from '../state'

const adminSelector = (state: StoreState) => state.admin
export const adminLoggedInSelector = createSelector(adminSelector, (admin: AdminState) => admin.isLogged)
